"use client";

import { createContext } from "react";
import type { PubSub, PubSubDefinition } from "@huub-web/utils";

export type PubSubContextState<T extends PubSubDefinition> = PubSub<T>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PubSubContext = createContext<PubSubContextState<any> | undefined>(
  undefined,
);
